import cx from "classnames";
import values from "lodash/values";
import PropTypes from "prop-types";
import React from "react";

import BadgeType from "../../constants/ChatBadgeTypes";
import SvgIcon from "../common/SvgIcon";
import iconSprite from "../../../../images/img/chat/icons.svg";

const Badge = ({ isCollapsed, label, type }) => {
    const typeToIconMapping = {
        [BadgeType.CERTIFIED]: "icon-checkmark",
        [BadgeType.ELITE]: "icon-star",
        [BadgeType.OFFICIAL]: "icon-shield",
    };

    return (
        <span
            className={cx({
                badge: true,
                "is-collapsed": isCollapsed,
                [`badge-${BadgeType[type].toLowerCase()}`]: true,
            })}
        >
            <span className="badge-icon-wrapper">
                <SvgIcon src={iconSprite} id={typeToIconMapping[type]} />
            </span>

            {!isCollapsed && (
                <span className="badge-label">
                    <strong>{label}</strong>
                </span>
            )}
        </span>
    );
};

Badge.defaultProps = {
    isCollapsed: false,
};

Badge.propTypes = {
    isCollapsed: PropTypes.bool,
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(values(BadgeType)).isRequired,
};

export default Badge;
